import { buildQueryString } from '../utils/buildQueryString'
import { createRestApiClient } from '../utils/createRestApiClient'

const PERPS_BASE_URL = 'https://mainnet-gw.sodex.dev/api/v1/perps'
const SPOT_BASE_URL = 'https://mainnet-gw.sodex.dev/api/v1/spot'

/**
 * Sodex REST API クライアントを生成する
 * @param params.market 現物または先物のマーケット種別
 * @param params.createHeaders プロキシ経由時の追加ヘッダー
 * @param params.proxy プロキシ base URL
 * @returns REST API クライアント
 */
export const createClient = ({
  market,
  createHeaders,
  proxy,
}: {
  market: 'perps' | 'spot'
  createHeaders?: () => Promise<Record<string, string>>
  proxy?: string
}) => {
  const baseUrl = market === 'perps' ? PERPS_BASE_URL : SPOT_BASE_URL

  return createRestApiClient({
    buildRequestData: async ({ method, path, query }) => {
      const queryString = buildQueryString(query)
      const queryWithQuestionMark = queryString ? `?${queryString}` : ''
      const url = `${baseUrl}${path}${queryWithQuestionMark}`
      const proxyHeaders = createHeaders ? await createHeaders() : {}

      return {
        url,
        headers: {
          Accept: 'application/json',
          ...proxyHeaders,
        },
        body: undefined,
      }
    },
    getDelayForRetry: ({ statusCode }) => {
      if (statusCode === 429) {
        return 10_000
      }
      if (statusCode >= 500) {
        return 1000
      }
      return undefined
    },
    proxy,
  })
}
